import style from './WhiteMainBackgroundWithHeading.module.css';

const WhiteMainBackgroundWithHeading = ({ children, heading }) => {
	return (
		<div className={style.main}>
			<div className={style.heading}>
				<span>{heading}</span>
			</div>
			{children}
		</div>
	);
};

export default WhiteMainBackgroundWithHeading;
